/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Change_Type_HeaderInputs */

const en_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Type`)
};

const fr_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de modification`)
};

const de_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungstyp`)
};

const it_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia tipo`)
};

const ru_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить тип`)
};

const es_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tipo`)
};

const zh_cn2_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改类型`)
};

const ja_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプの変更`)
};

const hi_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन का प्रकार`)
};

const pt_pt2_compare_event_groups_csv_change_type_header = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar tipo`)
};

/**
* | output |
* | --- |
* | "Change Type" |
*
* @param {Compare_Event_Groups_Csv_Change_Type_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_change_type_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Change_Type_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Change_Type_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "de") return de_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "it") return it_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "es") return es_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_change_type_header(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_change_type_header(inputs)
	return en_compare_event_groups_csv_change_type_header(inputs)
});